import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MbDialogRef, MbDialogBody, MbButton, MbDialogHeader, MbDialogFooter } from '@am/moebius';
import { ReqService } from '@core/services';
import * as purchaseLinks from './disney-purchase-policy.configure';
// TODO: Este componente no se esta usando
@Component({
  selector: 'disney-purchase-policy',
  standalone: true,
  imports: [CommonModule, MbDialogHeader, MbDialogBody, MbButton, MbDialogFooter],
  templateUrl: './disney-purchase-policy.component.html',
  styleUrls: ['./disney-purchase-policy.component.scss'],
})
export class ModalDisneyPurchasePolicyComponent implements OnInit {
  public dispoLink: string;
  public officialSiteLink: string;
  public attachTicketsLink: string;
  public firstStepImage: string;
  public secondStepImage: string;
  public thirdStepImage: string;
  public fourthStepImage: string;

  @ViewChild('templateDialog', { static: true })
  templateDialog: TemplateRef<any>;

  constructor(
    public dialog: MbDialogRef<ModalDisneyPurchasePolicyComponent>,
    private reqService: ReqService,
  ) {
    const LOCALE = this.reqService.getLocale();
    const IMAGE_BASE_PATH = `/hotels/dist/es-AR/browser/assets/images/disney`;

    this.firstStepImage = `${IMAGE_BASE_PATH}-calendar.svg`;
    this.secondStepImage = `${IMAGE_BASE_PATH}-tickets.svg`;
    this.thirdStepImage = `${IMAGE_BASE_PATH}.svg`;
    this.fourthStepImage = `${IMAGE_BASE_PATH}-info.svg`;

    if (LOCALE === 'pt-BR') {
      this.dispoLink = purchaseLinks.BR_DISPO_LINK;
      this.officialSiteLink = purchaseLinks.BR_OFFICIAL_SITE_LINK;
      this.attachTicketsLink = purchaseLinks.BR_ATTACH_TICKETS_LINK;
    } else {
      this.dispoLink = purchaseLinks.AR_DISPO_LINK;
      this.officialSiteLink = purchaseLinks.AR_OFFICIAL_SITE_LINK;
      this.attachTicketsLink = purchaseLinks.AR_ATTACH_TICKETS_LINK;
    }
  }

  ngOnInit() {}
}
